import * as R from 'ramda'
import {
  all,
  put,
  select,
  fork,
  take,
} from 'redux-saga/effects'

import {
  createTakeEveryName,
} from 'helpers/SagaUtil'
import {
  CHANGE_VALUE_SUCCESS,
  CHANGE_REFRESH_RATE_VALUE,
  CHANGE_RESOLUTION_VALUE,
  CHANGE_SIZE_VALUE,
  CHANGE_VENDOR_VALUE,
  CHANGE_PART_NUMBER_VALUE,
} from './constants'
import {
  getActions
} from './actions'
import getSelectors from './selectors'

function loadSagas(actionPath, selectorPath, elementId) {
  const {
    updateResolutionValue,
    updateSizeValue,
    updateVendorValue,
    updatePartNumberValue,
    updateRefreshRateValue,
    changeValueSuccess,
  } = getActions(actionPath)

  const {
    vendorRefSelector,
    sizeRefSelector,
    resolutionRefSelector,
    refreshRateRefSelector,
    valuesSelector,
  } = getSelectors(selectorPath)

  const takeEveryName = createTakeEveryName(actionPath)

  function* changePartNumberValue(action) {
    const { index, partNumber } = action
    yield put(updatePartNumberValue(index, partNumber))
    yield put(changeValueSuccess())
  }

  function* changeRefreshRateValue(action) {
    const { index, panelRefreshRateId } = action
    const values = yield select(refreshRateRefSelector)
    const value = values.find(({ panelRefreshRateId: id }) => id === panelRefreshRateId)
    const { value: refreshRate } = value
    yield put(updateRefreshRateValue(index, panelRefreshRateId, refreshRate))
    yield put(changeValueSuccess())
  }

  function* changeSizeValue(action) {
    const { index, panelSizeId } = action
    const values = yield select(sizeRefSelector)
    const value = values.find(({ panelSizeId: id }) => id === panelSizeId)
    const { value: size } = value
    yield put(updateSizeValue(index, panelSizeId, size))
    yield put(changeValueSuccess())
  }

  function* changeResolutionValue(action) {
    const { index, panelResolutionId } = action
    const values = yield select(resolutionRefSelector)
    const value = values.find(({ panelResolutionId: id }) => id === panelResolutionId )
    const { width, height } = value
    yield put(updateResolutionValue(index, panelResolutionId, width, height))
    yield put(changeValueSuccess())
  }

  function* changeVendorValue(action) {
    const { index, panelVendorId } = action
    const values = yield select(vendorRefSelector)
    const value = values.find(({ panelVendorId: id }) => id === panelVendorId )
    const { value: vendorName } = value
    yield put(updateVendorValue(index, panelVendorId, vendorName))
    yield put(changeValueSuccess())
  }

  function* watchUpdateRefreshRate() {
    yield takeEveryName(CHANGE_REFRESH_RATE_VALUE, changeRefreshRateValue)
  }

  function* watchUpdateSize() {
    yield takeEveryName(CHANGE_SIZE_VALUE, changeSizeValue)
  }

  function* watchUpdateResolution() {
    yield takeEveryName(CHANGE_RESOLUTION_VALUE, changeResolutionValue)
  }

  function* watchUpdateVendor() {
    yield takeEveryName(CHANGE_VENDOR_VALUE, changeVendorValue)
  }

  function* watchUpdatePartNumber() {
    yield takeEveryName(CHANGE_PART_NUMBER_VALUE, changePartNumberValue)
  }

  return function* () {
    yield all([
      fork(watchUpdateRefreshRate),
      fork(watchUpdateResolution),
      fork(watchUpdateSize),
      fork(watchUpdateVendor),
      fork(watchUpdatePartNumber)
    ])
  }
}

export {
  loadSagas,
}
